export const MAX_FILE_SIZE = 15728640